import {
    Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent,
    Typography,
} from '@mui/material';

export interface WidgetOption<T = any> {
    label: string;
    value: string;
    component: React.ComponentType<{ value: T; onChange: (value: T) => void }>;
    helperText?: string;
    getDefaultValue?: () => T;
}

interface WidgetSelectorProps<T = any> {
    widgets: WidgetOption<T>[];
    selected: string;
    onWidgetChange: (value: string) => void;
    label: string;
    widgetValue: T;
    onWidgetValueChange: (value: T) => void;
    showNoneOption?: boolean;
}

export const WidgetSelector = <T, >({
    widgets,
    selected,
    onWidgetChange,
    label,
    widgetValue,
    onWidgetValueChange,
    showNoneOption,
}: WidgetSelectorProps<T>): JSX.Element => {
    const handleChange = (e: SelectChangeEvent<string>): void => {
        onWidgetChange(e.target.value as string);
    };
    const activeWidget = widgets.find((w) => w.value === selected);
    const ActiveWidget = activeWidget?.component;

    return (
        <Box display="grid" gap={2}>
            <FormControl size="small">
                <InputLabel>{label}</InputLabel>
                <Select label={label} value={selected} onChange={handleChange}>
                    (
                    {showNoneOption && <MenuItem value="none"><em>None</em></MenuItem> }
                    )
                    {widgets.map((w) => (
                        <MenuItem key={w.value} value={w.value}>{w.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            {activeWidget?.helperText && (
                <Typography color="text.secondary" sx={{ mb: 2 }} variant="body2">
                    {activeWidget.helperText}
                </Typography>
            )}
            {ActiveWidget && widgetValue ? (
                <ActiveWidget value={widgetValue} onChange={onWidgetValueChange} />
            ) : null}
        </Box>
    );
};
